export const socialMediaIcons = [
  {
    id: 1,
    href: "#",
    className: "icon-facebook",
  },
  {
    id: 2,
    href: "#",
    className: "icon-twitter",
  },
  {
    id: 3,
    href: "#",
    className: "icon-linkedin2",
  },
  {
    id: 4,
    href: "#",
    className: "icon-instagram",
  },
];
